export default {
  data() {
    return {
      showMenu: false,
      showCloseBtn: true,
    };
  },
  computed: {
    albumId() {
      return this.album.is_private
        ? `${this.album.hash}-${this.album.hash_password}`
        : this.album.id;
    },
    privateTags() {
      return localStorage.getItem('private-tags') || null;
    },
    downloadUrl() {
      let url = this.$route.params.hash;
      const tag = this.$route.params.tag;

      if (url) {
        url+= '/download';
      } else {
        url = '#';
      }

      if (tag) {
        url+= `?tag=${tag}`;
      }

      return url;
    },
    mobileMainMenu() {
      return this.$store.getters.MOBILE_MAIN_MENU;
    },
    mobileFavoritesMenu() {
      return this.$store.getters.MOBILE_FAVORITES_MENU;
    },
    favoritesLength() {
      let favorites = [];

      if (this.favorites && this.favorites.length > 0) {
        this.favorites.forEach((album) => {
          if (album.albumId === this.album.id) {
            album.items.forEach((photo) => {
              favorites.push(photo);
            });
          }
        });
      }

      return favorites.length;
    },
  },
  methods: {
    goTo(path) {
      if (this.$router.currentRoute.path !== path) {
        this.$router.push(path);
      }

      this.$store.dispatch('SET_MOBILE_MAIN_MENU', false);
    },
    isActiveRoute(path) {
      return this.currentRoutePath.replace(/\/$/, '') === path;
    },
  },
};
